import { render, staticRenderFns } from "./ObjectTypesPicker.vue?vue&type=template&id=887e55d4&lang=pug&"
import script from "./ObjectTypesPicker.vue?vue&type=script&lang=js&"
export * from "./ObjectTypesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports